
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 20.025a9.738 9.738 0 01-3.9-.787A10.099 10.099 0 012.925 17.1c-.9-.9-1.612-1.958-2.137-3.175a9.738 9.738 0 01-.788-3.9C0 8.775.242 7.55.725 6.35A10.49 10.49 0 012.75 3.138c.867-.942 1.908-1.7 3.125-2.276C7.092.287 8.425 0 9.875 0c.35 0 .708.017 1.075.05s.742.092 1.125.175c-.15.75-.1 1.458.15 2.125s.625 1.22 1.125 1.663c.5.441 1.096.745 1.787.912.692.167 1.405.125 2.138-.125-.433.983-.37 1.925.188 2.825.558.9 1.387 1.367 2.487 1.4A9.824 9.824 0 0120 10.05a9.587 9.587 0 01-.788 3.862 10.292 10.292 0 01-2.137 3.175 9.994 9.994 0 01-3.175 2.15 9.738 9.738 0 01-3.9.788zm-1.5-12c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.447 1.447 0 008.5 5.026c-.417 0-.77.146-1.063.438A1.447 1.447 0 007 6.525c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zm-2 5c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063a1.446 1.446 0 00-1.062-.437c-.417 0-.77.146-1.063.438A1.447 1.447 0 005 11.524c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zm6.5 1c.283 0 .52-.096.713-.287a.968.968 0 00.287-.713.968.968 0 00-.287-.713.968.968 0 00-.713-.287.968.968 0 00-.713.287.968.968 0 00-.287.713c0 .283.096.52.287.713.192.191.43.287.713.287zm-3 4c2.033 0 3.838-.7 5.412-2.1 1.575-1.4 2.438-3.183 2.588-5.35-.833-.367-1.488-.867-1.962-1.5a5.357 5.357 0 01-.963-2.125 5.688 5.688 0 01-3.3-1.65 5.961 5.961 0 01-1.7-3.3c-1.333-.033-2.504.208-3.512.725-1.009.517-1.85 1.18-2.526 1.988A8.673 8.673 0 002.513 7.35C2.17 8.3 2 9.192 2 10.025c0 2.217.78 4.104 2.338 5.662 1.558 1.559 3.445 2.338 5.662 2.338z","fill":"currentColor"}})])
          )
        }
      }
    